module.exports = __webpack_public_path__ + "static/3-8815e650eab0d2d89d4e85f052166126.png";